<template>
  <v-row
    justify="start"
    align="start"
    v-bind="$attrs"
  >
    <v-col
      v-if="isRow"
      cols="12"
    >
      <v-row>
        <span
          v-for="property in content"
          v-show="property && !property.omit"
          :key="`property-${property.value}`"
          :class="property.class ? property.class : ''"
        >{{ property.text }}:
          <skeleton
            v-if="isLoading"
            width="100"
            height="15"
          />
          <template v-else>
            <strong
              v-if="!property.component"
              :style="`color: ${getColor(property)};`"
            >{{ getPropertyValue(property) }}</strong>
            <component
              :is="property.component"
              :value="getPropertyValue(property)"
              :color="getColor(property)"
              :property="property"
            />
          </template>
        </span>
      </v-row>
    </v-col>
    <v-col
      v-else
      cols="12"
    >
      <span
        v-for="property in content"
        v-show="property && !property.omit"
        :key="`property-${property.value}`"
        :class="property.class ? property.class : ''"
      >{{ property.text }}:
        <skeleton
          v-if="isLoading"
          width="100"
          height="15"
        />
        <template v-else>
          <strong
            v-if="!property.component"
            :style="`color: ${getColor(property)};`"
          >{{ getPropertyValue(property) }}</strong>
          <component
            :is="property.component"
            :value="getPropertyValue(property)"
            :color="getColor(property)"
            :property="property"
          />
        </template>
      </span>
    </v-col>
  </v-row>
</template>

<script>
import ReplaceAcentoFilter from 'Arch/filters/ReplaceAcentoFilter';
import DataViewMixin from 'Arch/mixins/DataViewMixin';
import TelefoneFilter from '../../filters/TelefoneFilter';

export default {
  name: 'DataViewList',
  mixins: [DataViewMixin],
  props: {
    value: {
      type: [Object, Array],
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
    },
    compare: {
      type: Array,
      default() {
        return [];
      },
    },
    omits: {
      type: Array,
      default() {
        return [];
      },
    },
    row: {
      type: Boolean,
    },
    autofill: {
      type: [Boolean, String],
      default: '',
    },
    color: {
      type: String,
      default: '#2ABD49',
    },
    wrongColor: {
      type: String,
      default: '#a91314',
    },
  },
  data: () => ({
    content: [],
  }),
  computed: {
    getColor() {
      return (property) => (this.setProperty(property)
        ? this.setColor(property.wrong)
        : '#202433');
    },
    getPropertyValue() {
      return (property) => this.overrideEmptyValue(
        this.setProperty(property),
      );
    },
    setColor() {
      return (key) => (!key ? this.color : this.wrongColor);
    },
    hasCompares() {
      return this.getCompare && this.getCompare.length;
    },
    getCompare() {
      return this.compare;
    },
    setProperty() {
      return (property) => (property && property.handle
        ? property.handle(property.value)
        : this.getProperty(property.value));
    },
    hasOmits() {
      return this.omits && this.omits.length;
    },
    isRow() {
      return this.row;
    },
  },
  watch: {
    getCompare: {
      handler(value) {
        if (value) {
          this.handleColorIfHasCompares();
        }
      },
    },
  },
  created() {
    if (this.hasOmits) {
      this.handleOmits();
    }
  },
  methods: {
    overrideEmptyValue(value) {
      if (this.autofill && !value) {
        if (typeof this.autofill === 'string') {
          return this.autofill;
        }
        return '';
      }
      return value;
    },
    handleCurrency(key) {
      return this.getCurrency(key);
    },
    handleTel(key) {
      const tel = this.handleProperty(key);

      return TelefoneFilter(tel);
    },
    handleProperty(key) {
      return this.getProperty(key);
    },
    handleCep(key) {
      return this.getCep(key);
    },
    handleState(key) {
      return this.setState(key);
    },
    handleCnpj(key) {
      return this.getCnpj(key);
    },
    handleCpf(key) {
      return this.getCpf(key);
    },
    handleDateOfBirth(key) {
      return this.getDateOfBirth(key);
    },
    handleDate(key, format) {
      return this.getDateOfBirth(key, format);
    },
    handleColorIfHasCompares() {
      if (this.hasCompares) {
        this.handleColors();
      }
    },
    formatDocument(key) {
      const cpfCnpj = this.handleProperty(key);

      if (cpfCnpj) {
        if (cpfCnpj.length <= 11) {
          return this.handleCpf(key);
        }
        return this.handleCnpj(key);
      }
      return cpfCnpj;
    },
    handleOmits() {
      const omits = [];
      this.omits.forEach(
        (key) => {
          this.getContentByKeyAndOverride(
            key,
            (overrideContent) => omits.push({
              ...overrideContent,
              omit: true,
            }),
          );
        },
      );
      this.handleContent(omits);
    },
    getContentByKeyAndOverride(key, cb) {
      const overrideContent = this.content.find(
        (content) => content.value === key,
      );
      if (overrideContent && cb) {
        cb(overrideContent);
      }
    },
    handleColors() {
      const values = [];
      const overrides = [];
      this.getCompare.forEach(
        (obj) => {
          if (!obj) return;
          Object.keys(obj)
            .forEach((key) => {
              const item = values.find((value) => value.key === key);

              if (!item) {
                values.push({
                  key,
                  value: obj[key],
                });
              }
              if (
                item && item.value && obj[key]
                  && (this.isEqualAndHasSameLength(item.value, obj[key]))
              ) {
                this.getContentByKeyAndOverride(
                  key,
                  (overrideContent) => overrides.push({
                    ...overrideContent,
                    wrong: true,
                  }),
                );
              }
            });
        },
      );
      this.handleContent(overrides);
    },
    isEqualAndHasSameLength(item, item2) {
      const overrideItem1 = ReplaceAcentoFilter(item);
      const overrideItem2 = ReplaceAcentoFilter(item2);
      return (!this.isEqualInLowercase(overrideItem1, overrideItem2)
                  || !this.hasSameLength(overrideItem1, overrideItem2));
    },
    isEqualInLowercase(item = '', item2 = '') {
      return (item && item2)
      && this.isEqual(
        this.transformToString(item).toLowerCase(),
        this.transformToString(item2).toLowerCase(),
      );
    },
    transformToString(item) {
      return String(item);
    },
    isEqual(item, item2) {
      return item === item2;
    },
    hasSameLength(item = '', item2 = '') {
      return (item && item2)
      && this.isEqual(
        this.transformToString(item).length,
        this.transformToString(item2).length,
      );
    },
    handleContent(contents = []) {
      if (contents && contents.length) {
        contents.forEach(
          (content) => {
            const contentIndex = this.content.findIndex(
              (item) => item.value === content.value,
            );

            if (contentIndex > -1) {
              this.content.splice(contentIndex, 1, content);
            }
          },
        );
      }
    },
  },
};
</script>

<style scoped>
span {
  display: block;
  margin: .4rem auto;
}

span .skeleton {
  display: inline-block;
  margin: 0 auto;
}

span strong {
  font-weight: 500;
  margin-left: .4rem;
}
</style>
